import * as styledComponents from "styled-components";

export const theme = {
  isDesktop: false,
  colors: {
    primary: "#0A0529",
  },
};

export type Theme = typeof theme;
const styled =
  styledComponents.default as styledComponents.ThemedStyledInterface<Theme>;

export const { createGlobalStyle, css } =
  styledComponents as unknown as styledComponents.ThemedStyledComponentsModule<Theme>;

export default styled;
